import axios from 'axios';

const token = localStorage.getItem('user-token');
const api_url = process.env.VUE_APP_API_VIDA_URL;

export default {
  async getMessagingHistoryByPolicyId(policyId, prospectId) {
    try {
      const response = await axios.get(
        `${api_url}/policies/${policyId}/messages`,
        {
          params: {
            prospectId,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getMessagingEmailEventsByHistoryId(historyId) {
    const response = await axios.get(
      `${api_url}/messaging/history/${historyId}/events`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  },

  async getSubjects() {
    try {
      const response = await axios.get(`${api_url}/messaging/subjects`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async resendMessaging(payload) {
    try {
      const response = await axios.post(
        `${api_url}/messaging/resend`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
};
